// CONSTANTS are all caps.
const NS = 'ProductsFilters';
const CLS = 'productsFilters';
const WG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/productsFilters.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'

export class ProductsFilters {
	constructor($el) {
		// $el is the widget node return by the loadProductsFilters function
		this.$el = $el;
	}

	init() {
		this.setProductsFilters();
		this.showCollapseGroups();
	}

	setProductsFilters() {
		// Add Some logic here
		let This = this;
		const $wg = $(this.$el);
		let $toggleBtn = $wg.find('.refine-btn');
		let $doneBtn = $wg.find('.mobile-done');
		let $resetBtn = $wg.find('.mobile-reset');
		let $filters = $wg.find('#productFilters');

		$toggleBtn.on('click', function() {
			if (This.isOnBreakpoint()) {
				$wg.addClass('is-open');
			}
		});

		$doneBtn.on('click', function() {
			if (This.isOnBreakpoint()) {
				$wg.removeClass('is-open');
				$wg.attr('style', '');
			}
		});

		$resetBtn.on('click', function() {
			$filters.find('input[type="checkbox"]').each(function() {
				$(this).prop('checked', false);
			});

			$wg.removeClass('is-open');
		});

		$(window).on('resize', function() {
			if (!(This.isOnBreakpoint())) {
				$wg.removeClass('is-open');
			}
		});

		// check (ALL) by default
		$wg.find('input[value="all"]').prop('checked', true);
	}

	showCollapseGroups() {
		let This = this;
		const $wg = $(this.$el);
		let $groups = $wg.find(WG + 'group');

		$groups.each(function() {
			let $title = $(this).find(WG + 'title');
			let $collapse = $(this).find('.collapse');

			$(this).find('input[type="checkbox"]').each(function() {
				if ($(this).is(':checked')) {
					$title
						.removeClass('collapsed')
						.attr('aria-expanded', true);
					$collapse.addClass('show');

					// break out
					return false;
				}
			});
		});
	}

	isOnBreakpoint() {
		// md
		return window.innerWidth < 768;
	}

	// Add more functions like on above here
}



// WEBPACK FOOTER //
// C:/Users/GavinDow/source/repos/FrontEndWebsite/src/views/widgets/productsFilters/js/productsFilters.js